interface ToucanLogoProps {
  className?: string
  size?: number
}

export function ToucanLogo({ className = '', size = 40 }: ToucanLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Body */}
      <ellipse cx="24" cy="40" rx="13" ry="17" fill="#1a1a2e" />

      {/* White chest patch */}
      <ellipse cx="22" cy="46" rx="6" ry="9" fill="#fefefe" />

      {/* Head */}
      <circle cx="28" cy="20" r="12" fill="#1a1a2e" />

      {/* Eye ring - blue skin around eye */}
      <circle cx="32" cy="18" r="5.5" fill="#0ea5e9" />
      <circle cx="32" cy="18" r="3.5" fill="#0c4a6e" />

      {/* Eye */}
      <circle cx="33" cy="17" r="1.8" fill="#1a1a2e" />
      <circle cx="33.5" cy="16.5" r="0.7" fill="#ffffff" />

      {/* Beak - proper toucan shape curving down */}
      <path
        d="M38 16
           C42 14 52 13 56 16
           C60 19 58 26 54 30
           C50 34 44 35 40 32
           C38 30 38 24 38 16Z"
        fill="url(#beakGradient)"
      />

      {/* Beak top ridge/highlight */}
      <path
        d="M38 16 C43 14 50 14 55 17"
        stroke="#ea580c"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />

      {/* Beak mouth line */}
      <path
        d="M38 24 C44 25 50 26 54 26"
        stroke="#1a1a2e"
        strokeWidth="1"
        strokeLinecap="round"
        fill="none"
        opacity="0.4"
      />

      {/* Beak nostril */}
      <ellipse cx="43" cy="20" rx="1.2" ry="0.8" fill="#1a1a2e" opacity="0.4" />

      {/* Beak tip - darker */}
      <path
        d="M54 26 C56 28 56 30 54 30 C52 32 50 32 50 30 C52 29 54 28 54 26Z"
        fill="#0f766e"
      />

      {/* Tail feathers */}
      <path
        d="M11 44 C7 50 5 56 7 60 C9 56 13 52 15 48"
        fill="#1a1a2e"
      />
      <path
        d="M13 46 C9 52 8 57 11 60 C12 56 15 52 17 49"
        fill="#1a1a2e"
      />

      {/* Feet */}
      <path
        d="M20 55 L18 62 M22 55 L22 62 M24 55 L26 62"
        stroke="#64748b"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Wing detail */}
      <path
        d="M16 36 C12 40 12 46 16 50"
        stroke="#2a2a4e"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />

      <defs>
        <linearGradient id="beakGradient" x1="38" y1="16" x2="56" y2="32" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#f97316" />
          <stop offset="35%" stopColor="#facc15" />
          <stop offset="65%" stopColor="#22c55e" />
          <stop offset="100%" stopColor="#14b8a6" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export function ToucanLogoMark({ className = '', size = 32 }: ToucanLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Head */}
      <circle cx="16" cy="22" r="13" fill="#1a1a2e" />

      {/* Eye ring - blue skin */}
      <circle cx="20" cy="19" r="5" fill="#0ea5e9" />
      <circle cx="20" cy="19" r="3.2" fill="#0c4a6e" />

      {/* Eye */}
      <circle cx="21" cy="18" r="1.5" fill="#1a1a2e" />
      <circle cx="21.5" cy="17.5" r="0.5" fill="#ffffff" />

      {/* Beak - proper curved shape */}
      <path
        d="M27 17
           C30 15 38 14 42 17
           C46 20 44 26 40 30
           C36 34 32 34 28 31
           C26 29 26 23 27 17Z"
        fill="url(#beakGradientMark)"
      />

      {/* Beak ridge */}
      <path
        d="M27 17 C31 15 37 15 41 18"
        stroke="#ea580c"
        strokeWidth="1.2"
        strokeLinecap="round"
        fill="none"
      />

      {/* Beak mouth line */}
      <path
        d="M27 24 C32 25 37 26 40 25"
        stroke="#1a1a2e"
        strokeWidth="0.8"
        strokeLinecap="round"
        fill="none"
        opacity="0.4"
      />

      {/* Beak tip */}
      <path
        d="M40 26 C42 28 42 30 40 30 C38 31 37 31 37 29 C38 28 40 27 40 26Z"
        fill="#0f766e"
      />

      <defs>
        <linearGradient id="beakGradientMark" x1="27" y1="17" x2="42" y2="30" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#f97316" />
          <stop offset="35%" stopColor="#facc15" />
          <stop offset="65%" stopColor="#22c55e" />
          <stop offset="100%" stopColor="#14b8a6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
